var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-map-info-window-div",on:{"click":_vm.jumpToDetail}},[_c('img',{attrs:{"src":_vm.info.icon,"alt":""}}),_c('div',{staticClass:"text-info"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.info.name))]),_c('div',{staticClass:"intro"},[_vm._v(" "+_vm._s(_vm.info.intro)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }